import { GE_URL } from "./constants";

export const fetchDaily = id => fetch(`${GE_URL}?a=graph&g=30&i=${id}`)
    .then(e => e.json())
    .catch(err => console.error("Something went wrong",err))

export const fetchDays = id => fetch(`${GE_URL}?a=graph&start=${Math.floor(Date.now() / 1000)}&g=1440&i=${id}`)
    .then(e => e.json())
    .catch(err => console.error("Something went wrong",err))

export const getItem = id => fetch(`${GE_URL}?a=guidePrice&i=${id}`)
    .then(e => e.json())
    .catch(err => console.error("Something went wrong",err))


// WEBPACK FOOTER //
// ./src/ui/item/functions/fetchData.js